import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Box, FormControl, InputLabel, Select, MenuItem,
    Typography, CircularProgress
} from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

export default function ExportFormatModal({ open, onClose, onExport, isExporting, title = "Export Data" }) {
    const [format, setFormat] = useState('csv');

    useEffect(() => {
        if (open) {
            setFormat('csv');
        }
    }, [open]);

    const handleExport = () => {
        onExport(format);
    };

    return (
        <Dialog 
            open={open} 
            onClose={isExporting ? undefined : onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{ sx: { borderRadius: 3, padding: 1 } }}
        >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 'bold' }}>
                <FileDownloadOutlinedIcon color="primary" /> {title}
            </DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    Select your preferred file format for the export.
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    <FormControl fullWidth size="small">
                        <InputLabel>File Format</InputLabel>
                        <Select
                            value={format}
                            label="File Format"
                            onChange={(e) => setFormat(e.target.value)}
                            disabled={isExporting}
                        >
                            <MenuItem value="csv">CSV Document</MenuItem>
                            <MenuItem value="excel">Excel Spreadsheet (.xlsx)</MenuItem>
                            <MenuItem value="pdf">PDF Document</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions sx={{ padding: '16px 24px' }}>
                <Button onClick={onClose} variant="outlined" sx={{ borderRadius: 2 }} disabled={isExporting}>
                    Cancel
                </Button>
                <Button
                    onClick={handleExport}
                    variant="contained"
                    color="primary"
                    sx={{ borderRadius: 2 }}
                    disabled={isExporting}
                >
                    {isExporting ? <CircularProgress size={20} color="inherit" /> : 'Download File'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
